/*****************************************************************************/
/*  Date:      Oct 11 2021                                                   */
/*  Author:    Ben Wakutz                                                    */
/*  Purpose:   grabs the tierlogo for the ROI Remake                         */
/*                                                                           */
/*****************************************************************************/

import React from 'react';
import styles from '../styles/roi.module.scss';

import ListLogo from '../images/list.png';
import BronzeLogo from '../images/bronze.png';
import SilverLogo from '../images/silver.png';
import GoldLogo from '../images/gold.png';
import PlatinumLogo from '../images/platinum.png';
import RubyLogo from '../images/ruby.png';
import DiamondLogo from '../images/diamond.png';
import EmeraldLogo from '../images/emerald-badge@2x.png';

const TierLogo = ({ tier }) => {
  //console.log("IN GET TIERLOGO ->",tier);
  //console.log('these are my props', this.props);

  if (tier) {
    //console.log('this is my found tier ----> ', foundTier);

    switch (tier) {
      case 'List':
        return <img src={ListLogo} alt='List' className={styles.brandLogos} />;
      case 'Bronze':
        return <img src={BronzeLogo} alt='Bronze' className={styles.brandLogos} />;
      case 'Silver':
        return <img src={SilverLogo} alt='Silver' className={styles.brandLogos} />;
      case 'Gold':
        return <img src={GoldLogo} alt='Gold' className={styles.brandLogos} />;
      case 'Platinum':
        return <img src={PlatinumLogo} alt='Platinum' className={styles.brandLogos} />;
      case 'Emerald':
        return <img src={EmeraldLogo} alt='Emerald' className={styles.brandLogos} />;
      case 'Ruby':
        return <img src={RubyLogo} alt='Ruby' className={styles.brandLogos} />;
      case 'Diamond':
        return <img src={DiamondLogo} alt='Diamond' className={styles.brandLogos} />;
      default:
        return <img src={ListLogo} alt='List' className={styles.brandLogos} />;
    }
  }
};

export default TierLogo;
